<template>
	<div class="flex flex-col bg-background h-screen">
		<div class="flex items-center bg-white py-2 shadow-default" @click="emitDismiss">
			<app-button class="btn btn-transparent transparent small mx-3" icon="menu" @click="toggleMenu" />
			<div class="flex-1 md:flex-none">
				<img
					v-if="isB2B && isManagingOneBusiness"
					alt="logo"
					class="h-8 my-2 duration-100 mr-4"
					:src="user.restaurants[0].logo"
				/>
				<img
					v-else
					alt="logo"
					:class="`h-8 py-1 my-2 duration-100 ${!isOpen ? 'mr-4' : 'mr-10'}`"
					src="../../assets/images/baboon_newlogo_red.png"
				/>
			</div>
			<div class="hidden md:flex flex-1 mr-4" id="app-teleport-header" />
			<POSBusinessStatus
				v-if="isManagingOneBusiness && !isB2B"
				:business-id="user.restaurants[0].restaurantID"
				:city-id="user.restaurants[0].city.id"
				:online="user.restaurants[0].status === 1"
				:businessClosingTime="user.restaurants[0].closingTime"
			/>
			<div v-if="!isManagingOneBusiness && !isB2B">
				<div
					id="baboon-profile-businesses-widget"
					class="relative flex flex-end items-center mx-4 cursor-pointer"
					@click="toggleBusinessDropDown"
				>
					<div class="relative">
						<app-icon icon="filters" class="text-2xl" />
						<div
							style="width: 15px; height: 15px; top: -5px; right: -10px"
							class="flex absolute bg-primary rounded-full items-center justify-center top-0"
						>
							<span class="text-white" style="font-size: 10px">{{ selectedRestaurants.length }}</span>
						</div>
					</div>

					<div
						v-if="isBusinessWidgetVisible"
						class="absolute bg-white shadow-lg right-0 p-2"
						style="top: 40px; width:300px; z-index: 10000; max-height: 500px; overflow: auto;"
						@click="$event.stopPropagation()"
					>
						<div class="flex flex-row items-end right-0 gap-1">
							<p class=" hover:underline text-tiny" @click="selectAll">Select all</p>
							<span>/</span>
							<p class=" hover:underline text-tiny" @click="deselectAll">Deselect all</p>
						</div>
						<app-input
							v-model="computedSearch"
							name="search"
							placeholder="Search"
							:icon="searching ? 'spin-loading' : 'search'"
							class="pt-2"
							@update:modelValue="_onSearchInput"
						/>
						<div v-for="rest in userRestaurants" :key="rest.restaurantID" @click="$event.stopPropagation()">
							<div class="flex flex-row items-center" @click="toggleRestSelection(rest)">
								<div class="flex w-4 h-4 border-1 border-gray-300 items-center justify-center mr-2">
									<app-icon icon="save" class="text-tiny" v-if="checkIfRestIsSelected(rest)" />
								</div>
								<span>{{ rest.restaurantName }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				id="baboon-profile-widget"
				v-if="user"
				class="relative flex flex-end items-center mx-4 cursor-pointer"
				@click="toggleProfileDropDown"
			>
				<img
					v-if="user && user['photoUrl']"
					:src="user['photoUrl']"
					class="h-8 w-8 object-contain rounded-full border-border-color border-1 mr-2"
					alt=""
				/>
				<img
					v-else
					src="../../assets/images/logo-mini.png"
					class="h-8 w-8 object-contain rounded-full border-border-color border-1 mr-2"
					alt=""
				/>
				{{ user.name }} {{ user.surname }}
				<app-icon icon="sort-down" />
				<div
					v-if="isDropDownVisible"
					class="absolute bg-white shadow-lg right-0 p-2"
					style="top: 40px; width:200px; z-index: 10000"
				>
					<div class="flex justify-around">
						<img
							@click="$i18next.changeLanguage('sq')"
							class="w-9 transition duration-300 transform hover:scale-110"
							src="../../assets/images/AL.png"
							alt="albanian"
						/>
						<img
							@click="$i18next.changeLanguage('en')"
							class="w-9 transition duration-300 transform hover:scale-110"
							src="../../assets/images/UK.png"
							alt="english"
						/>
						<img
							@click="$i18next.changeLanguage('it')"
							class="w-9 transition duration-300 transform hover:scale-110"
							src="../../assets/images/IT.png"
							alt="italian"
						/>
					</div>
					<app-line />
					<p @click="redirect(RouteNames.ChangePassword)" class="my-1">
						<app-icon class="text-secondary text-xl mr-2" icon="lock" />
						<span class="text-secondary text-16">{{ $t('changePassword') }}</span>
					</p>
					<app-line />
					<p @click="logout()" class="my-1">
						<app-icon class="text-secondary text-xl mr-2" icon="logout" />
						<span class="text-secondary text-16">{{ $t('logout') }}</span>
					</p>
				</div>
			</div>
		</div>
		<div class="flex flex-1">
			<Sidebar @onSidebarItemOpened="onSidebarItemOpened" />
			<div class="app-main-content relative" @click="emitDismiss">
				<div id="app-content" class="app-router-view-container" :class="routeName">
					<div class="md:hidden flex flex-1" id="app-teleport-mobile-header" />
					<router-view v-if="loaded" />
				</div>
				<app-loader :loading="loading" />
			</div>
		</div>
	</div>
	<finance-alert-modal v-if="alert.title" :alert="alert" />
</template>

<script>
	import RouteNames from '@/router/names';
	import Sidebar from './Sidebar/Sidebar';
	import AppLoader from '@/components/app/AppLoader';
	import AppIcon from '@/components/app/AppIcon';
	import { mapGetters } from 'vuex';
	import UtilityService from '@/services/UtilityService';
	import moment from 'moment';
	import POSBusinessStatus from '@/components/POSBusinessStatus';
	import { debounce } from 'lodash';
	import AuthService from '@/services/AuthService';
	import FinanceAlertModal from '@/components/company/FinanceAlertModal.vue';
	import AppInput from '@/components/app/AppInput.vue';
	import AppButton from '@/components/app/AppButton.vue';

	export default {
		name: 'Content',
		components: {
			AppButton,
			AppInput,
			FinanceAlertModal,
			Sidebar,
			AppLoader,
			AppIcon,
			POSBusinessStatus,
		},
		computed: {
			...mapGetters({
				customClass: 'sidebar',
				user: 'user',
				selectedRestaurants: 'selectedRestaurants',
				isB2B: 'isB2B',
				alert: 'alert',
			}),
			isOpen() {
				return this.customClass === 'opened';
			},
			routeName() {
				return this.$route.name;
			},
			isManagingOneBusiness() {
				return this.user?.restaurants?.length === 1;
			},
			computedSearch: {
				get() {
					return this.search;
				},
				set: debounce(function(newValue) {
					this.search = newValue;
				}, 100),
			},
		},
		data: () => ({
			RouteNames,
			loadingActiveSession: false,
			activeSession: {},
			clockInterval: {},
			currentSession: '00:00:00',
			working: [],
			hasActiveSession: false,
			loaded: false,
			loading: false,
			isDropDownVisible: false,
			isBusinessWidgetVisible: false,
			showStartModal: false,
			search: '',
			userRestaurants: [],
		}),
		methods: {
			isDescendant(parent, child) {
				let node = child;
				while (node != null) {
					if (node === parent) {
						return true;
					}
					node = node.parentNode;
				}
				return false;
			},
			emitDismiss($event) {
				this.emitter.emit('appContentClicked');
				const parent = document.getElementById('baboon-profile-widget');
				const child = $event.target;
				if (!this.isDescendant(parent, child)) {
					this.isDropDownVisible = false;
				}
				const businessParentParent = document.getElementById('baboon-profile-businesses-widget');
				if (!this.isDescendant(businessParentParent, child)) {
					this.isBusinessWidgetVisible = false;
				}
			},
			toggleMenu() {
				const val = !this.isOpen ? 'opened' : '';
				this.$store.dispatch('updateSidebar', val);
			},
			toggleProfileDropDown() {
				this.isDropDownVisible = !this.isDropDownVisible;
			},
			toggleBusinessDropDown() {
				this.isBusinessWidgetVisible = !this.isBusinessWidgetVisible;
			},
			redirect(name) {
				if (name) {
					this.$router.push({ name });
				} else {
					this.$notificationService.info('Not implemented yet');
				}
			},
			logout() {
				AuthService.deleteRegId(this.user.id, this.user.regId)
					.then(() => {
						if (this.isB2B) {
							this.$router.push({ name: RouteNames.B2B_Login });
						} else {
							this.$router.push({ name: RouteNames.Login });
						}
					})
					.catch(() => {
						this.$notificationService.error('Checkout Failed');
					})
					.finally(() => {
						this.$store.dispatch('logout');
						this.isDropDownVisible = false;
					});
			},
			onSidebarItemOpened() {
				if (UtilityService.isMobile()) {
					this.$store.dispatch('updateSidebar', 'opened');
				}
			},
			selectAll() {
				this.$store.commit(
					'UPDATE_SELECTED_BUSINESSES',
					this.user.restaurants.map(({ restaurantID }) => restaurantID)
				);
			},
			deselectAll() {
				this.$store.commit('UPDATE_SELECTED_BUSINESSES', []);
			},
			getUserRestaurants() {
				this.userRestaurants = this.user.restaurants;
			},
			_onSearchInput: debounce(function() {
				this.getUserRestaurants();
				if (this.search !== '') {
					this.userRestaurants = this.userRestaurants.filter((restaurant) =>
						restaurant.restaurantName?.toLowerCase().includes(this.search?.toLowerCase())
					);
				}
			}, 300),
			toggleRestSelection(rest) {
				const newSelection = [...this.selectedRestaurants];
				const index = newSelection.indexOf(rest.restaurantID);
				if (index > -1) {
					newSelection.splice(index, 1);
				} else {
					newSelection.push(rest.restaurantID);
				}
				this.$store.commit('UPDATE_SELECTED_BUSINESSES', newSelection);
			},
			checkIfRestIsSelected(rest) {
				return this.selectedRestaurants.indexOf(rest.restaurantID) > -1;
			},
		},
		mounted() {
			this.getUserRestaurants();
			this.clockInterval = setInterval(() => {
				if (this.hasActiveSession && this.activeSession) {
					const start = moment(this.activeSession.cDate);
					const end = moment();
					const diff = end.diff(start, 'seconds');
					this.currentSession = moment()
						.startOf('day')
						.add('seconds', diff)
						.format('HH:mm:ss');
				}
			}, 1000);
		},
		beforeCreate() {
			setTimeout(() => {
				this.loaded = true;
			}, 100);
			this.emitter.on('isLoading', (val) => {
				this.loading = val;
			});
		},
		beforeUnmount() {
			this.emitter.all.clear();
			clearInterval(this.clockInterval);
		},
		watch: {
			$route() {
				if (UtilityService.isMobile()) {
					this.$store.dispatch('updateSidebar', '');
				}
			},
		},
	};
</script>
